import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '@/app/Layout';
import { NotFound } from '@/app/NotFound';
import { LandingPage } from '@/features/landing/LandingPage';
import { ProductsListPage } from '@/features/products/ProductsListPage';
import { ProductDetailPage } from '@/features/products/ProductDetailPage';
import { CartPage } from '@/features/cart/CartPage';
import { CheckoutDetailsPage } from '@/features/checkout/CheckoutDetailsPage';
import { CheckoutConfirmationPage } from '@/features/checkout/CheckoutConfirmationPage';
/**
 * Root router.
 * All 7 storefront routes wrapped in shared Layout.
 * Entire app is wrapped in <DevOnlyGate> at main.tsx level.
 * See docs/plans/customer-storefront/03-routing-and-auth.md § Route table
 */
export function App() {
    return (_jsx(Routes, { children: _jsxs(Route, { element: _jsx(Layout, {}), children: [_jsx(Route, { path: "/", element: _jsx(LandingPage, {}) }), _jsx(Route, { path: "/products", element: _jsx(ProductsListPage, {}) }), _jsx(Route, { path: "/products/:slug", element: _jsx(ProductDetailPage, {}) }), _jsx(Route, { path: "/cart", element: _jsx(CartPage, {}) }), _jsx(Route, { path: "/checkout/details", element: _jsx(CheckoutDetailsPage, {}) }), _jsx(Route, { path: "/checkout/confirmation", element: _jsx(CheckoutConfirmationPage, {}) }), _jsx(Route, { path: "/404", element: _jsx(NotFound, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/404", replace: true }) })] }) }));
}
